module.exports = __webpack_public_path__ + "static/media/Milk_lite6.89ba8bbd.jpg";